
import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';

const HomePage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hig-construcao-servicos.pt';

  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Remodelação Completa',
      description: 'Transformamos a sua casa por completo com qualidade e rapidez'
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Renovação de Cozinhas',
      description: 'Cozinhas modernas e funcionais adaptadas ao seu estilo'
    },
    {
      icon: 'ri-drop-line',
      title: 'Casas de Banho',
      description: 'Remodelação completa de casas de banho com materiais de qualidade'
    },
    {
      icon: 'ri-brush-line',
      title: 'Pintura Interior/Exterior',
      description: 'Serviços de pintura profissional para renovar os seus espaços'
    },
    {
      icon: 'ri-hammer-line',
      title: 'Carpintaria',
      description: 'Trabalhos de carpintaria personalizados e móveis à medida'
    },
    {
      icon: 'ri-tools-line',
      title: 'Reparações Gerais',
      description: 'Pequenas e grandes reparações para manter a sua casa perfeita'
    }
  ];

  const projects = [
    {
      image: 'https://public.readdy.ai/ai/img_res/ad7f4e6eceaeff0aed6c7f3d8f027402.jpg',
      title: 'Renovação de Cozinha Moderna',
      location: 'Braga Centro'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Bright%20luxurious%20bathroom%20renovation%20with%20marble%20tiles%2C%20modern%20fixtures%2C%20glass%20shower%20enclosure%2C%20and%20elegant%20vanity.%20Contemporary%20Portuguese%20home%20bathroom%20design%20with%20high-end%20finishes%20and%20professional%20installation.%20Well-lit%20clean%20space%20with%20premium%20materials%2C%20sophisticated%20lighting%20and%20minimal%20shadows.%20Abundant%20natural%20and%20artificial%20light%20creating%20a%20bright%2C%20welcoming%20atmosphere.&width=400&height=300&seq=bathroom6&orientation=landscape',
      title: 'Casa de Banho de Luxo',
      location: 'São Victor'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Bright%20complete%20home%20renovation%20showing%20before%20and%20after%20transformation%20of%20a%20Portuguese%20house%20interior.%20Well-lit%20modern%20living%20room%20with%20new%20flooring%2C%20fresh%20paint%2C%20updated%20lighting%2C%20and%20contemporary%20furniture.%20Professional%20renovation%20work%20demonstrating%20quality%20craftsmanship%20and%20design%20excellence.%20Abundant%20natural%20light%20with%20minimal%20shadows%20creating%20a%20bright%2C%20welcoming%20space.&width=400&height=300&seq=living6&orientation=landscape',
      title: 'Remodelação Completa',
      location: 'Maximinos'
    }
  ];

  const galleryImages = [
    {
      image: 'https://readdy.ai/api/search-image?query=Bright%20beautiful%20modern%20kitchen%20renovation%20in%20Braga%20Portugal%20with%20white%20cabinets%2C%20quartz%20countertops%2C%20stainless%20steel%20appliances%2C%20and%20pendant%20lighting.%20Clean%20contemporary%20design%20with%20island%20and%20bar%20stools.%20Professional%20renovation%20work%20showing%20quality%20craftsmanship%20and%20attention%20to%20detail%20in%20Portuguese%20home.%20Well-lit%20space%20with%20abundant%20natural%20light%20and%20minimal%20shadows.&width=400&height=300&seq=gallery10&orientation=landscape',
      title: 'Cozinha Moderna',
      category: 'Cozinhas'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Bright%20elegant%20bathroom%20renovation%20with%20marble%20tiles%2C%20modern%20vanity%2C%20glass%20shower%2C%20and%20contemporary%20fixtures%20in%20Portuguese%20home.%20Luxury%20bathroom%20design%20with%20high-end%20finishes%2C%20LED%20lighting%2C%20and%20premium%20materials.%20Professional%20renovation%20work%20in%20Braga%20showing%20sophisticated%20style%20and%20quality%20installation.%20Well-lit%20space%20with%20abundant%20natural%20light%20and%20minimal%20shadows.&width=400&height=300&seq=gallery11&orientation=landscape',
      title: 'Casa de Banho Elegante',
      category: 'Casas de Banho'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Bright%20spacious%20living%20room%20renovation%20with%20modern%20furniture%2C%20fresh%20paint%2C%20new%20flooring%2C%20and%20contemporary%20lighting%20in%20Portuguese%20house.%20Open%20concept%20design%20with%20comfortable%20seating%20area%2C%20coffee%20table%2C%20and%20decorative%20elements.%20Professional%20renovation%20work%20showing%20quality%20craftsmanship%20and%20modern%20interior%20design.%20Well-lit%20space%20with%20abundant%20natural%20light%20and%20minimal%20shadows.&width=400&height=300&seq=gallery12&orientation=landscape',
      title: 'Sala de Estar',
      category: 'Remodelação Completa'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Bright%20professional%20exterior%20house%20painting%20in%20Braga%20Portugal%20showing%20fresh%20white%20and%20gray%20paint%20on%20traditional%20Portuguese%20home.%20Clean%20lines%2C%20modern%20color%20scheme%2C%20and%20quality%20finish%20work.%20Renovation%20team%20completing%20exterior%20painting%20project%20with%20professional%20equipment%20and%20attention%20to%20detail.%20Well-lit%20daylight%20scene%20with%20minimal%20shadows%20and%20excellent%20visibility.&width=400&height=300&seq=gallery13&orientation=landscape',
      title: 'Pintura Exterior',
      category: 'Pintura'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Bright%20custom%20carpentry%20work%20showing%20built-in%20wardrobes%20and%20storage%20solutions%20in%20Portuguese%20home%20bedroom.%20Modern%20wooden%20furniture%20with%20clean%20lines%2C%20quality%20finish%2C%20and%20functional%20design.%20Professional%20carpentry%20renovation%20work%20in%20Braga%20demonstrating%20skilled%20craftsmanship%20and%20attention%20to%20detail.%20Well-lit%20workspace%20with%20abundant%20natural%20light%20and%20minimal%20shadows.&width=400&height=300&seq=gallery14&orientation=landscape',
      title: 'Carpintaria Personalizada',
      category: 'Carpintaria'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Bright%20modern%20bedroom%20renovation%20with%20built-in%20wardrobes%2C%20fresh%20paint%2C%20new%20flooring%2C%20and%20contemporary%20lighting%20in%20Portuguese%20home.%20Clean%20minimalist%20design%20with%20comfortable%20bed%2C%20nightstands%2C%20and%20storage%20solutions.%20Professional%20renovation%20work%20showing%20quality%20craftsmanship%20and%20modern%20interior%20design%20in%20Braga.%20Well-lit%20space%20with%20abundant%20natural%20light%20and%20minimal%20shadows.&width=400&height=300&seq=gallery15&orientation=landscape',
      title: 'Quarto Moderno',
      category: 'Remodelação Completa'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Bright%20traditional%20Portuguese%20kitchen%20renovation%20with%20wooden%20cabinets%2C%20stone%20countertops%2C%20and%20rustic%20charm.%20Classic%20design%20with%20modern%20appliances%2C%20ceramic%20tiles%2C%20and%20warm%20lighting.%20Professional%20renovation%20work%20in%20Braga%20showing%20blend%20of%20traditional%20and%20contemporary%20elements%20with%20quality%20craftsmanship.%20Well-lit%20space%20with%20abundant%20natural%20light%20and%20minimal%20shadows.&width=400&height=300&seq=gallery16&orientation=landscape',
      title: 'Cozinha Tradicional',
      category: 'Cozinhas'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Bright%20compact%20bathroom%20renovation%20with%20modern%20tiles%2C%20space-saving%20fixtures%2C%20and%20efficient%20design%20in%20Portuguese%20apartment.%20Small%20bathroom%20maximizing%20space%20with%20wall-mounted%20vanity%2C%20corner%20shower%2C%20and%20contemporary%20finishes.%20Professional%20renovation%20work%20in%20Braga%20showing%20smart%20design%20solutions%20and%20quality%20installation.%20Well-lit%20space%20with%20excellent%20lighting%20and%20minimal%20shadows.&width=400&height=300&seq=gallery17&orientation=landscape',
      title: 'Casa de Banho Compacta',
      category: 'Casas de Banho'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Bright%20interior%20painting%20project%20showing%20fresh%20white%20walls%2C%20ceiling%20work%2C%20and%20professional%20finish%20in%20Portuguese%20home%20living%20room.%20Clean%20painting%20work%20with%20quality%20materials%2C%20proper%20preparation%2C%20and%20attention%20to%20detail.%20Renovation%20team%20completing%20interior%20painting%20in%20Braga%20with%20professional%20equipment%20and%20techniques.%20Well-lit%20space%20with%20abundant%20natural%20light%20and%20minimal%20shadows.&width=400&height=300&seq=gallery18&orientation=landscape',
      title: 'Pintura Interior',
      category: 'Pintura'
    }
  ];

  const testimonials = [
    {
      name: 'Maria Silva',
      location: 'Braga',
      text: 'Excelente trabalho! Remodelaram a nossa cozinha em tempo recorde e com qualidade excepcional.',
      rating: 5
    },
    {
      name: 'João Santos',
      location: 'Guimarães',
      text: 'Profissionais muito competentes. Recomendo vivamente para qualquer tipo de remodelação.',
      rating: 5
    },
    {
      name: 'Ana Costa',
      location: 'Barcelos',
      text: 'Transformaram completamente a nossa casa. Resultado final superou todas as expectativas!',
      rating: 5
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="HIG Construção e Serviços - Remodelações Braga Portugal"
        description="HIG Construção e Serviços - Empresa especializada em remodelações de casas em Braga, Portugal. Serviços de renovação completa, cozinhas, casas de banho, pintura e carpintaria. Orçamentos gratuitos em Braga."
        keywords="HIG Construção, remodelações Braga, renovação casas Portugal, obras Braga, carpintaria, pintura"
        canonical={siteUrl}
        pageType="LocalBusiness"
      />

      {/* Navigation */}
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
                HIG Construção e Serviços
              </h1>
            </div>
            
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="#inicio" className="text-gray-900 hover:text-teal-600 px-3 py-2 text-sm font-medium cursor-pointer">Início</a>
                <a href="#servicos" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium cursor-pointer">Serviços</a>
                <a href="#projetos" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium cursor-pointer">Projetos</a>
                <a href="#galeria" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium cursor-pointer">Galeria</a>
                <a href="#sobre" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium cursor-pointer">Sobre</a>
                <a href="#contacto" className="bg-teal-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-teal-700 cursor-pointer whitespace-nowrap">Contacto</a>
              </div>
            </div>
            
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-700 hover:text-gray-900 focus:outline-none"
              >
                <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'} text-xl`}></i>
              </button>
            </div>
          </div>
        </div>
        
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              <a href="#inicio" className="text-gray-900 block px-3 py-2 text-base font-medium cursor-pointer">Início</a>
              <a href="#servicos" className="text-gray-700 block px-3 py-2 text-base font-medium cursor-pointer">Serviços</a>
              <a href="#projetos" className="text-gray-700 block px-3 py-2 text-base font-medium cursor-pointer">Projetos</a>
              <a href="#galeria" className="text-gray-700 block px-3 py-2 text-base font-medium cursor-pointer">Galeria</a>
              <a href="#sobre" className="text-gray-700 block px-3 py-2 text-base font-medium cursor-pointer">Sobre</a>
              <a href="#contacto" className="text-gray-700 block px-3 py-2 text-base font-medium cursor-pointer">Contacto</a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section id="inicio" className="relative bg-cover bg-center bg-no-repeat min-h-screen flex items-center" 
               style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Bright%20professional%20home%20renovation%20team%20working%20on%20a%20beautiful%20Portuguese%20house%20in%20Braga.%20Modern%20construction%20site%20with%20workers%20installing%20new%20materials%2C%20scaffolding%2C%20and%20renovation%20equipment.%20Bright%20daylight%20scene%20showing%20quality%20craftsmanship%20and%20professional%20renovation%20services.%20Clean%2C%20organized%20workspace%20with%20construction%20materials%20and%20tools.%20Well-lit%20environment%20with%20abundant%20natural%20light%20and%20minimal%20shadows.&width=1920&height=1080&seq=hero6&orientation=landscape')` }}>
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-left">
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Remodelações de <span className="text-teal-400">Qualidade</span> em Braga
            </h2>
            <p className="text-xl md:text-2xl text-gray-200 mb-8 max-w-2xl">
              Transformamos a sua casa com serviços profissionais de remodelação. 
              Qualidade garantida e prazos cumpridos em toda a região de Braga.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="#contacto" className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap text-center">
                Orçamento Gratuito
              </a>
              <a href="#servicos" className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap text-center">
                Ver Serviços
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="servicos" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Os Nossos Serviços
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Oferecemos uma gama completa de serviços de remodelação para transformar 
              a sua casa no espaço dos seus sonhos.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-2xl text-teal-600`}></i>
                </div>
                <h4 className="text-xl font-semibold text-gray-900 mb-4">
                  <strong>{service.title}</strong>
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section id="projetos" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Projetos Realizados
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Veja alguns dos nossos trabalhos mais recentes e inspire-se para 
              a sua próxima remodelação.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="w-full h-64 object-cover object-top"
                />
                <div className="p-6">
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">
                    <strong>{project.title}</strong>
                  </h4>
                  <p className="text-gray-600 flex items-center">
                    <i className="ri-map-pin-line mr-2"></i>
                    {project.location}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="galeria" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Galeria de Trabalhos
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Explore a nossa extensa galeria de projetos concluídos e veja a qualidade 
              do nosso trabalho em diferentes tipos de remodelações.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {galleryImages.map((item, index) => (
              <div key={index} className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-80 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <div className="text-sm text-teal-300 mb-2">{item.category}</div>
                    <h4 className="text-lg font-semibold">{item.title}</h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <a href="#contacto" className="bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap">
              Ver Mais Projetos
            </a>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="sobre" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Sobre a Nossa Empresa
              </h3>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Somos uma empresa especializada em <strong>remodelações de casas em Braga</strong>, 
                com anos de experiência no setor. A nossa equipa de profissionais qualificados 
                está comprometida em oferecer serviços de <strong>renovação de qualidade</strong> 
                com prazos cumpridos e preços competitivos.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Trabalhamos em toda a região de <strong>Braga</strong>, oferecendo desde pequenas 
                reparações até <strong>remodelações completas</strong>. Cada projeto é único e 
                tratado com o máximo cuidado e atenção aos detalhes.
              </p>
              
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-teal-600 mb-2">150+</div>
                  <div className="text-gray-600">Projetos Concluídos</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-teal-600 mb-2">5+</div>
                  <div className="text-gray-600">Anos de Experiência</div>
                </div>
              </div>
            </div>
            
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Bright%20professional%20renovation%20team%20partnership%20in%20Braga%2C%20Portugal%20showing%20balanced%20collaboration%20between%20African%20and%20European%20workers%20on%20house%20renovation%20project.%20Equal%20representation%20of%20skilled%20professionals%20with%20African%20heritage%20and%20European%20heritage%20working%20together%20in%20safety%20gear%20using%20modern%20tools%20and%20equipment.%20Clean%2C%20organized%20construction%20site%20demonstrating%20quality%20craftsmanship%2C%20teamwork%20and%20professional%20renovation%20services.%20Well-lit%20environment%20with%20abundant%20natural%20light%20and%20minimal%20shadows.%20Diverse%20team%20of%20African%20and%20European%20backgrounds%20collaborating%20with%20expertise%20and%20attention%20to%20detail.&width=600&height=400&seq=team6&orientation=landscape"
                alt="Equipa de remodelações em Braga"
                className="w-full h-96 object-cover object-top rounded-xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              O Que Dizem os Nossos Clientes
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              A satisfação dos nossos clientes é a nossa maior recompensa. 
              Veja o que dizem sobre o nosso trabalho.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-lg">
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="fas fa-star text-yellow-400"></i>
                  ))}
                </div>
                <p className="text-gray-600 mb-6 italic">
                  "{testimonial.text}"
                </p>
                <div>
                  <div className="font-semibold text-gray-900">{testimonial.name}</div>
                  <div className="text-gray-500 text-sm">{testimonial.location}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contacto" className="py-20 bg-teal-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Contacte-nos Hoje
            </h3>
            <p className="text-xl text-teal-100 max-w-3xl mx-auto">
              Pronto para transformar a sua casa? Entre em contacto connosco 
              para um orçamento gratuito e sem compromisso.
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <div className="bg-white p-8 rounded-xl shadow-lg">
                <h4 className="text-2xl font-bold text-gray-900 mb-6">Informações de Contacto</h4>
                
                <div className="space-y-6">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4">
                      <i className="ri-map-pin-line text-xl text-teal-600"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">Localização</div>
                      <div className="text-gray-600">Avenida Dom Pedro Nunes 587<br />Vila Verde, Braga</div>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4">
                      <i className="ri-phone-line text-xl text-teal-600"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">Telefones</div>
                      <div className="text-gray-600">
                        <div>936 602 153</div>
                        <div>193 931 073</div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4">
                      <i className="ri-mail-line text-xl text-teal-600"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">Email</div>
                      <div className="text-gray-600">hanielany@gmail.com</div>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4">
                      <i className="ri-time-line text-xl text-teal-600"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">Horário</div>
                      <div className="text-gray-600">Seg-Sex: 8h-18h | Sáb: 9h-13h</div>
                    </div>
                  </div>

                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4">
                      <i className="fab fa-whatsapp text-xl text-green-600"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">WhatsApp</div>
                      <a 
                        href="https://wa.me/351936602153" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-green-600 hover:text-green-700 font-medium"
                      >
                        936 602 153
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <div className="bg-white p-8 rounded-xl shadow-lg">
                <h4 className="text-2xl font-bold text-gray-900 mb-6">Peça o Seu Orçamento</h4>
                
                <form 
                  className="space-y-6" 
                  data-readdy-form
                  id="orcamento-form"
                  action="https://readdy.ai/api/form/d466rkahchb23d4ef4tg"
                  method="POST"
                  onSubmit={(e) => {
                    e.preventDefault();
                    const formData = new FormData(e.target as HTMLFormElement);
                    const data = new URLSearchParams();
                    formData.forEach((value, key) => {
                      data.append(key, value.toString());
                    });
                    
                    fetch('https://readdy.ai/api/form/d466rkahchb23d4ef4tg', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                      },
                      body: data
                    }).then(() => {
                      alert('Pedido enviado com sucesso! Entraremos em contacto brevemente.');
                      (e.target as HTMLFormElement).reset();
                    }).catch(() => {
                      alert('Erro ao enviar pedido. Tente novamente.');
                    });
                  }}
                >
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Nome</label>
                      <input 
                        type="text" 
                        name="nome"
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                        placeholder="O seu nome"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Telefone</label>
                      <input 
                        type="tel" 
                        name="telefone"
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                        placeholder="O seu telefone"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                    <input 
                      type="email" 
                      name="email"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                      placeholder="O seu email"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Serviço</label>
                    <select 
                      name="tipo_servico"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm pr-8"
                    >
                      <option value="">Selecione o tipo de serviço</option>
                      <option value="Remodelação Completa">Remodelação Completa</option>
                      <option value="Renovação de Cozinha">Renovação de Cozinha</option>
                      <option value="Casa de Banho">Casa de Banho</option>
                      <option value="Pintura">Pintura</option>
                      <option value="Carpintaria">Carpintaria</option>
                      <option value="Reparações Gerais">Reparações Gerais</option>
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Mensagem</label>
                    <textarea 
                      rows={4}
                      name="mensagem"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                      placeholder="Descreva o seu projeto..."
                      maxLength={500}
                    ></textarea>
                    <div className="text-xs text-gray-500 mt-1">Máximo 500 caracteres</div>
                  </div>
                  
                  <button 
                    type="submit"
                    className="w-full bg-teal-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap"
                  >
                    Enviar Pedido de Orçamento
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/351936602153"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-50"
        aria-label="Contactar via WhatsApp"
      >
        <i className="fab fa-whatsapp text-2xl"></i>
      </a>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h5 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                HIG Construção e Serviços
              </h5>
              <p className="text-gray-400 leading-relaxed">
                Especialistas em remodelações de casas em Braga. 
                Qualidade, rapidez e preços competitivos.
              </p>
            </div>
            
            <div>
              <h6 className="font-semibold mb-4">Serviços</h6>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#servicos" className="hover:text-white cursor-pointer">Remodelação Completa</a></li>
                <li><a href="#servicos" className="hover:text-white cursor-pointer">Renovação Cozinhas</a></li>
                <li><a href="#servicos" className="hover:text-white cursor-pointer">Casas de Banho</a></li>
                <li><a href="#servicos" className="hover:text-white cursor-pointer">Pintura</a></li>
              </ul>
            </div>
            
            <div>
              <h6 className="font-semibold mb-4">Contacto</h6>
              <ul className="space-y-2 text-gray-400">
                <li>Avenida Dom Pedro Nunes 587</li>
                <li>Vila Verde, Braga</li>
                <li>936 602 153 | 193 931 073</li>
                <li>hanielany@gmail.com</li>
              </ul>
            </div>
            
            <div>
              <h6 className="font-semibold mb-4">Siga-nos</h6>
              <div className="flex space-x-4">
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="https://wa.me/351936602153" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-green-600 transition-colors cursor-pointer">
                  <i className="fab fa-whatsapp"></i>
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 HIG Construção e Serviços. Todos os direitos reservados. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white ml-2" rel="nofollow">Website Builder</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
